define('runTemplateTabsLayoutController',[
    'module',
    'runTemplateTabsLayoutView',
    'app',
    'jquery',
    'underscore',
    'tabsBaseController',
    'runTemplateTabsData',
    'entities/runtemplates'
], function(
    module,
    TabsLayoutView,
    App,
    $,
    _,
    TabBaseController,
    tabs
) {
    'use strict';

    var RunTemplateTabsLayoutController = _.extend(_.clone(TabBaseController),{
        model: App.request('runtemplate:model'),
        View: TabsLayoutView,
        tabs: tabs,

        showTabsRunTemplateLayout: function (region, tabName, id) {
            var defer = $.Deferred();
            this.model = App.request('runtemplate:model');
            this.model.set(this.model.idAttribute, id);

            if(this._layoutView && !this._layoutView.isDestroyed) {
                defer.resolve(this._layoutView.getRegion('tabs'), this._layoutView.model);
                this._layoutView.triggerMethod('show:active', tabName);
                return defer.promise();
            }

            this.model.fetch().done(_.bind(function() {

                this._layoutView = new TabsLayoutView({
                    model: this.model,
                    tabs: this.tabs
                });
                region.show(this._layoutView);
                this._layoutView.triggerMethod('show:active', tabName);

                defer.resolve(this._layoutView.getRegion('tabs'), this._layoutView.model);
            }, this));
            return defer.promise();
        }
    });

    module.exports = RunTemplateTabsLayoutController;
});
